export const TheDate = () => {
  return <>19/12/2025</>;
};
